import React from "react";
import { SectionContentProps } from "../../types";
import ClassicHero from "./ClassicHero";
import SplitHero from "./SplitHero";
import GlassCardHero from "./GlassCardHero";
import { UniversityHero } from "../../university";
import { EducaeetHero } from "../../educaeet";
import { HokHero } from "../../hok";
import OvanHero from "../../ovan/ovanhero/OvanHero";
import { CollegeHero } from "../../college";
import { SaasHero } from "../../saas";
import { CorporateHero } from "../../corporate";
import { AIHero } from "../../aistartup";
import { PortfolioHero } from "../../portfolio";

export default function HeroSection(props: SectionContentProps) {
    const { content } = props;
    
    if (content?.variant === "college") {
        return <CollegeHero {...props} />;
    }
    if (content?.variant === "saas") {
        return <SaasHero {...props} />;
    }
    if (content?.variant === "corporate") {
        return <CorporateHero {...props} />;
    }
    if (content?.variant === "aistartup") {
        return <AIHero {...props} />;
    }
    if (content?.variant === "portfolio") {
        return <PortfolioHero {...props} />;
    }

    const isUniversity = content?.variant === "university";
    const isEducaeet = content?.variant === "educaeet";
    const isSplit = content?.variant === "v2" || content?.variant === "hero-v2" || content?.align === "left";
    const isGlassCard = content?.variant === "v3" || content?.variant === "hero-v3";
    const isHok = content?.variant === "hok" || content?.variant === "hero-hok";
    const isOvan = content?.variant === "ovan";

    if (isUniversity) {
        return <UniversityHero {...props} />;
    }

    if (isEducaeet) {
        return <EducaeetHero {...props} />;
    }

    if (isGlassCard) {
        return <GlassCardHero {...props} />;
    }

    if (isSplit) {
        return <SplitHero {...props} />;
    }

    if (isHok) {
        return <HokHero {...props} />;
    }

    if (isOvan) {
        return <OvanHero {...props} />;
    }

    return <ClassicHero {...props} />;
}

